export enum routes {
    Home = '/',
    About = '/about',
    Apparel = '/apparel',
    TrainingGear = '/traininggear',
    TrainingProgram = '/trainingprogram',
    TrainingProgramIntro = '/trainingprogram#intro',
    TrainingProgramCompetition = '/trainingprogram#competition',
}
